module.exports = __webpack_public_path__ + "img/icon-switch.03b8fd94.svg";